import { render, staticRenderFns } from "./plugins.vue?vue&type=template&id=5e108a1d&scoped=true"
import script from "./plugins.vue?vue&type=script&lang=js"
export * from "./plugins.vue?vue&type=script&lang=js"
import style0 from "./plugins.vue?vue&type=style&index=0&id=5e108a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e108a1d",
  null
  
)

export default component.exports